module.exports = __webpack_public_path__ + "media/public/img/market_pulse/market_pulse-3-612c3c5b0e879414933838eb8a8b8b44.svg";